<template>

<div class="row plain-element">
  <div v-if="!isLoggedIn()" class="dashboard-cards">
    <NoPermissionComponent/>
  </div>
    <div v-if="getUsername() && getNestedSitesAndSeu()" class="dashboard" style="padding: 0px">
    <div class="row plain-element top-menu">
      <ul>
        <li>
          <router-link :to="{name: 'home'}" class="horizontal-link">Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'action-search'}" class="horizontal-link underline-green">Action Search
          </router-link>
        </li>
      </ul>
    </div>
  </div>
  <div class="row plain-element">
    <div class="row row-opportunities">
       <div class="row plain-element">
          <div v-if="getNestedSitesAndSeu()" class=" col col-12 col-sm-12 col-md-3 col-lg-3 plain-element">
            <div class="input-field  col col-12 col-sm-12 col-md-8 col-form">
              <div class="row plain-element text-start">
                <label class="label-search">Site Code</label>
              </div>
              <select v-model="site" name="site" id="site" @change="clearSeu()">
                <option value="" selected> All Sites</option>
                <option v-for="(key, value, index) in getNestedSitesAndSeu()" :key="index">
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="getNestedSitesAndSeu()" class=" col col-12 col-sm-12 col-md-3 col-lg-3 plain-element">
            <div class="input-field  col col-12 col-sm-12 col-md-8 col-form">
              <div class="row plain-element text-start">
                <label class="label-search">SEU</label>
              </div>
              <select v-model="seu" name="seu" id="seu" @change="clearSearch()">
                <option value="" selected> All SEU</option>
                <option v-for="(element, index) in getNestedSitesAndSeu()[site]" :key="index">
                  {{ element }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="getNestedSitesAndSeu()" class=" col col-12 col-sm-12 col-md-2 col-lg-2 plain-element">
            <div class="input-field  col col-12 col-sm-12 col-md-8 col-form">
              <div class="row plain-element text-start">
                <label class="label-search">Status</label>
              </div>
              <select v-model="status" name="status" id="status" @change="clearSearch()">
                <option value="open" selected>open</option>
                <option value="closed" selected> closed</option>
                <option value="" selected> All</option>
              </select>
            </div>
          </div>

          <div class=" col col-12 col-sm-12 col-md-4 col-lg-4 plain-element text-end">
            <div v-if="getNestedSitesAndSeu()" class="input-field  col col-12 col-sm-12 col-form">
              <div class="row searchbox-wrapper">
                <div class="row plain-element text-start">
                  <label class="label-search">Table Filter</label>
                </div>
                <input class="form-control" id="keyWordSearchbox" type="text" placeholder="e.g. Steam"
                       aria-label="e.g. Steam" v-model="search">
              </div>
            </div>
          </div>
       </div>
      <p class="w-100"></p>
      <div v-if="getUsername() && getLoader() == true" class="row">
        <div class="loader" id="loader"></div>
      </div>
      <div v-if="getActions()  && getLoader() == false" class="row plain-element">
        <div v-if="getResultCount() > 0" class="col col-sm-3 col-md-3 col-lg-3 plain-element text-start">
          <h6> {{ keywordFilteredList.length }} Results</h6>
        </div>
        <div class="col col-sm-6 col-md-6 col-lg-6 plain-element">
        </div>
        <div v-if="getResultCount() && keywordFilteredList.length > 0" class="col col-sm-3 col-md-3 col-lg-3 col-results plain-element text-end">
          <a target="_blank" v-if="site!='' && seu==''" :href="'/api/site-search-actions-download/' + site + '/'"
             class="btn btn-report">
            <i class="fas fa-file-download"></i>&nbsp; Download
          </a>
          <a target="_blank" v-else-if="site!='' && seu!=''"
             :href="'/api/seu-download/' + site + '/' + seu + '/'"
             class="btn btn-report">
            <i class="fas fa-file-download"></i>&nbsp; Download
          </a>
        </div>
      </div>
      <p class="w-100"></p>
      <div id="parent">
        <div id="child">
          <table v-if="getActions() && getLoader() == false" name="text" id="searchTable">
            <thead v-if="keywordFilteredList.length < 100 && keywordFilteredList.length > 0">
              <tr>
                <th @click="sort(0)">Action No.
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>

                </th>
                <th @click="sort(1)" class="text-center">Status
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>
                </th>
                <th @click="sort(2)" class="text-center">Created
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>
                </th>
                <th @click="sort(3)" class="text-center">Site Code
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>
                </th>
                <th @click="sort(4)" class="text-center">SEU
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>
                </th>
                <th @click="sort(5)" class="text-center">Event Type
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>
                </th>
                <th class="text-center th-description">Comment</th>
                <th @click="sortInt(7)" class="text-end">Cost
                  <span class="fa fa-stack">
                          <i class="fa fa-caret-down" aria-hidden="true"></i>
                          <i class="fa fa-caret-up" aria-hidden="true"></i>
                      </span>
                </th>
              </tr>
            </thead>
            <thead v-else-if="keywordFilteredList.length > 100">
              <tr>
                <th>Action No.
                </th>
                <th class="text-center">Status
                </th>
                <th class="text-center">Created
                </th>
                <th class="text-center">Site Code
                </th>
                <th class="text-center">SEU
                </th>
                <th class="text-center">Event Type
                </th>
                <th class="text-center th-description">Comment</th>
                <th class="text-end">Cost
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="action in keywordFilteredList" :key="action.id" @click="goToActionView(action.id.toString())">
                <td class="text-start field-opportunity">{{action.action_number}}</td>
                <td class="text-center field-number">{{action.status}}</td>
                <td class="text-center field-number">{{action.created_date}}</td>
                <td class="text-center field-number">{{action.site_code__site_code}}</td>
                <td class="text-center field-number">{{action.seu__seu}}</td>
                <td class="text-center field-opportunity">{{action.event_type__event_type}}</td>
                <td class="text-start field-description">{{action.comment | truncatechars(120) }}</td>
                <td class="text-end field-number">{{action.cost.toLocaleString()}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { sortTable, sortTableInt } from "@/common/tables.js";
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "ActionStandardSearch",
  components: {
      NoPermissionComponent,
  },
  data() {
    return {
      error: null,
      resultCount: null,
      search: "",
      active: "opportunities",
      siteList: null,
      searchQuery: null,
      site: "",
      seu: "",
      status: "",
    }
  },
  methods: {
    ...mapGetters(["getUsername", "getNestedSitesAndSeu", "isLoggedIn", "getLoader", "getResultCount", "getActions" ]),
    ...mapActions([ "performSetFormError", "fetchAllActions", "fetchNestedSitesAndSeu", "performSetFormError"]),
    getFullActionList() {
      this.fetchAllActions();
    },
    clearSeu() {
        if (this.site == "") {
          this.seu = ""
          this.status = ""
          this.search = ""
        } else {
          this.seu = ""
          this.status = ""
          this.search = ""
        }
    },
    clearSearch() {
       this.search = "";
    },
//    TABLE_SORTING FUNCTIONS
    sort(n) {
      sortTable(n)
    },
    sortInt(n) {
      sortTableInt(n)
    },
    goToActionView(id) {
      if (event.ctrlKey === true) {
//        let routeData = this.$router.resolve({ name: 'action-view', params: { id: id } });
//        window.open(routeData.href, '_blank');
        window.open(`/action-details/${id}`, '_blank');
      } else {
//        this.$router.push({ name: 'action-view', params: { id: id } });
//        location.href=(`/action-details/${id}`);
        window.open(`/action-details/${id}`, '_blank');
      }
    },
  },
  computed: {
    filteredList() {
        if (this.seu != ""  && this.site != "" && this.status != "" ) {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() == this.site.toLowerCase() &&
                      action.seu__seu.toLowerCase().includes(this.seu.toLowerCase()) &&
                      action.status.toLowerCase().includes(this.status.toLowerCase())
            })
        } else if (this.site != ""  && this.seu == "" && this.status == "") {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() == this.site.toLowerCase()
            })
        } else if (this.site != ""  && this.seu != "" && this.status == "") {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() == this.site.toLowerCase() &&
                     action.seu__seu.toLowerCase().includes(this.seu.toLowerCase())
            })
        } else if (this.site != "" && this.seu == "" && this.status != "") {
            return this.getActions().filter(action => {
              return action.site_code__site_code.toLowerCase() == this.site.toLowerCase() &&
                     action.status.toLowerCase().includes(this.status.toLowerCase())
            })
        } else if (this.site == "" && this.seu == "" && this.status != "") {
            return this.getActions().filter(action => {
              return action.status.toLowerCase().includes(this.status.toLowerCase())
            })
        } else {
          return this.getActions()
        }
    },
    keywordFilteredList() {
      return this.filteredList.filter(action => {
        return action.action_number.toLowerCase().includes(this.search.toLowerCase()) ||
               action.site_code__site_code.toLowerCase().includes(this.search.toLowerCase()) ||
               action.status.toLowerCase().includes(this.search.toLowerCase()) ||
               action.seu__seu.toLowerCase().includes(this.search.toLowerCase()) ||
               action.event_type__event_type.toLowerCase().includes(this.search.toLowerCase()) ||
               action.comment.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  filters: {
//  Just in case if some strings would be too long and would destroy a layout
    truncatechars (value, limit) {
      if (value) {
          if (value.length > limit) {
            value = value.substring(0, limit) + "...";
            }
            return value
        }
      }
  },
  created() {
    this.fetchNestedSitesAndSeu();
    this.performSetFormError(null);
    this.getFullActionList();
    document.title = "Action Search";
    window.scrollTo(0,0);
  },

}
</script>

